import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getAuth } from '../../selectors/access/auth'
import getRoleCombo from '../../services/role/getRoleCombo'
import commonActions from '../../actions/common'
import messageModalActions from '../../actions/modals/messageModal'
import { fetchRolesSuccess } from '../../actions/combos/combos'
import combosActionTypes from '../../constants/actions/combos/combos'
import { handleError } from '../errors/errorManager'

export function * fetchRoles () {
  try {
    yield put(commonActions.showLoader())
    const auth = yield select(getAuth)
    const roleCombo = yield call(getRoleCombo, auth.token)
    yield put(fetchRolesSuccess(roleCombo))
  } catch (error) {
    const customHandler = function * () {
      yield put(messageModalActions.openErrorMessageModal('MESSAGES.FETCH_COMBO_ERROR'))
    }
    yield call(handleError, { error, customHandler })
  } finally {
    yield put(commonActions.hideLoader())
  }
}

export function * watchFetchRoles () {
  yield takeLatest(combosActionTypes.FETCH_ROLES, fetchRoles)
}
